import { memo, useEffect, useState } from "react"
import { CardOrderItemStyled, ContentOrderItemstyled } from "components/Core/Order/CardOrder/CardOrderItem.styled"
import { ICardOrderItem, IShippinGroupDetail } from "interfaces/IOrder"
import { ContractorStatusEnum, ContractorTypeEnum } from "enums/ContractorEnum"
import { getShippinGroupDetail } from "services/ShippingGroupService"
import useCancelToken from "hooks/UseCancelToken"
import Logger from "classes/Logger"
import SkeletonGrid from "components/Commons/Skeleton/SkeletonGrid"

const CardOrderItem = memo(
  ({
    id,
    orderId,
    channel,
    source,
    target,
    currentStatus,
    statusSG,
    custom,
  }: ICardOrderItem) => {
    const [shippingGroupDetail, setShippingGroupDetail] = useState<IShippinGroupDetail | null>(null)
    const { newCancelToken, isCancel } = useCancelToken()

    useEffect(() => {
      if (statusSG === undefined) {
        getShippingGroupInfo()
      }
      // eslint-disable-next-line
    }, [statusSG])

    const getShippingGroupInfo = async () => {
      try {
        const {
          data: { message: shippingGroup },
        } = await getShippinGroupDetail(orderId, id, newCancelToken())
        
        setShippingGroupDetail(shippingGroup)
      } catch (error: any) {
        Logger.error(error)
        if (isCancel(error)) return
        console.error('Error al obtener información del ShippingGroup:', error)
      } finally {
        console.log('finally call service getShippingGroupInfo')
      }
    }

    const contractorShippingGroupStatus = (status: string) => {
      if(status === ContractorStatusEnum.new) {
        return "new"
      } else if(status === ContractorStatusEnum.incomplete) {
        return "incomplete"
      } else if(status === ContractorStatusEnum.complete) {
        return "complete"
      }
    }

    const contractorStatus = () => {
      return contractorShippingGroupStatus(custom?.infoCTO?.statusCTO)
    }

    const contractorShippingGroupType = (type: string) => {
      if(type === ContractorTypeEnum.reception) {
        return "reception"
      } else if(type === ContractorTypeEnum.installation) {
        return "installation"
      }
    }

    const paramType = statusSG || contractorShippingGroupType(shippingGroupDetail?.custom?.infoCTO?.orderType || '') || '';
    const pathStatus = contractorStatus() || contractorShippingGroupStatus(shippingGroupDetail?.custom?.infoCTO?.statusCTO || '') || '';

    return (
      <>
        <ContentOrderItemstyled>
          <CardOrderItemStyled to={`/order/${paramType}/${id}/${orderId}/${pathStatus}`}
          >
            <div className="content-item-order">
              
              <span className="relevant-title item">TRANSFERENCIA A ORGANIZACIÓN</span>
              
              <span className="item">
                ORDEN:
                <span>{orderId}</span>
              </span>

              <span className="item">
                SG:
                <span>{id}</span>
              </span>

              {/* Condicional para mostrar diferentes filas según el tipo de orden */}
              {statusSG === undefined && !shippingGroupDetail ? (
                <SkeletonGrid count={2} height={20} />
              ) : custom?.infoCTO?.orderType === "Recepcion" || shippingGroupDetail?.custom?.infoCTO?.orderType === "Recepcion" ? (
                <>
                  {target?.source?.id && (
                    <span className="item">
                      Source:
                      <span>{target?.source?.id || shippingGroupDetail?.custom?.infoCTO?.target?.source?.id}</span>
                    </span>
                  )}
                  {channel && (
                    <span className="item">
                      Canal:
                      <span>{channel}</span>
                    </span>
                  )}
                </>
              ) : custom?.infoCTO?.orderType === "Instalacion" || shippingGroupDetail?.custom?.infoCTO?.orderType === "Instalacion" ? (
                <>
                  {statusSG === undefined && !shippingGroupDetail ? (
                    <SkeletonGrid count={3} height={20} />
                  ) : (
                    <>
                      {(target?.source?.id || shippingGroupDetail?.custom?.infoCTO?.target?.source?.id) && (
                        <span className="item">
                          Sitio:
                          <span>{target?.source?.id || shippingGroupDetail?.custom?.infoCTO?.target?.source?.id}</span>
                        </span>
                      )}
                      {(custom?.infoCTO?.target?.region || shippingGroupDetail?.custom?.infoCTO?.target?.region) && (
                        <span className="item">
                          Región:
                          <span>{custom?.infoCTO?.target?.region || shippingGroupDetail?.custom?.infoCTO?.target?.region}</span>
                        </span>
                      )}
                      {(custom?.infoCTO?.target?.commune || shippingGroupDetail?.custom?.infoCTO?.target?.commune) && (
                        <span className="item">
                          Comuna:
                          <span>{custom?.infoCTO?.target?.commune || shippingGroupDetail?.custom?.infoCTO?.target?.commune}</span>
                        </span>
                      )}
                    </>
                  )}
                </>
              ) : null}
              
            </div>
          </CardOrderItemStyled>
        </ContentOrderItemstyled>
      </>
    )
  },
)

export default CardOrderItem
